module.exports = __webpack_public_path__ + "img/delete.31cdc1e1.svg";